import { render, staticRenderFns } from "./cockpitPanel.vue?vue&type=template&id=66364310&scoped=true"
import script from "./cockpitPanel.vue?vue&type=script&lang=js"
export * from "./cockpitPanel.vue?vue&type=script&lang=js"
import style0 from "./cockpitPanel.vue?vue&type=style&index=0&id=66364310&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66364310",
  null
  
)

export default component.exports